import axios from "axios";

import {
  GET_TOPICS,
  ADD_TOPIC,
  DELETE_TOPIC,
  UPDATE_TOPIC,
  SUBSCRIBE_TOPIC,
  UNSUBSCRIBE_TOPIC,
  GET_USER_SUBSCRIPTION,
} from "../constants/urls";

import {
  setAdditionalParams,
  setSubscriptionFrequency,
  setSubscriptionTypes,
} from "./subscription";

import {
  CURATED_REGHUB_TOPICS_ARE_LOADING,
  CURATED_REGHUB_TOPICS_LOADED_WITH_ERROR,
  CURATED_REGHUB_TOPICS_HAVE_LOADED,
  GET_SINGLE_CURRENT_TOPIC_IS_LOADING,
  GET_SINGLE_CURRENT_TOPIC_LOADED_WITH_ERROR,
  GET_SINGLE_CURRENT_TOPIC_IS_LOADED,
  RESTART_TOPIC_MESSAGES,
  TOPIC_SUCCESS_MESSAGE_RAISED,
  TOPIC_ERROR_MESSAGE_RAISED,
} from "./actionTypes";
import {
  IMAGE_BASE,
  TRUE,
  TITLE_BESIDE_LOGO,
} from "../constants/stringConstants";

export function curatedRegHubTopicsHaveBeenLoaded(
  curatedRegHubTopics,
  mySelectionTopics,
  userToken
) {
  return {
    type: CURATED_REGHUB_TOPICS_HAVE_LOADED,
    curatedRegHubTopics,
    mySelectionTopics,
    userToken,
  };
}

export function curatedRegHubTopicsAreLoading(curatedRegHubTopicsAreLoading) {
  return {
    type: CURATED_REGHUB_TOPICS_ARE_LOADING,
    curatedRegHubTopicsAreLoading,
  };
}

export function curatedRegHubTopicsLoadedWithError() {
  return {
    type: CURATED_REGHUB_TOPICS_LOADED_WITH_ERROR,
  };
}

export function getCuratedRegHubTopics(userToken, userEmail) {
  return (dispatch) => {
    dispatch(curatedRegHubTopicsAreLoading(true));
    axios({
      url: GET_TOPICS,
      params: {
        usertoken: userToken,
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    })
      .then((response) => {
        if (response.data.RegHub_response) {
          response.data.RegHub_response.forEach(
            (o) => (
              (o.TOPIC_ICON_NAME = o.TOPIC_NAME.replace(/\s+/g, "-")),
              (o.TOPIC_ICON_PATH = IMAGE_BASE + o.TOPIC_ICON_NAME + ".jpg")
            )
          );

          dispatch(
            curatedRegHubTopicsHaveBeenLoaded(
              response.data.RegHub_response.filter(
                (o) =>
                  o.CREATED_BY === TITLE_BESIDE_LOGO || o.TOPIC_TYPE === "TOPIC"
              ),
              response.data.RegHub_response.filter(
                (o) =>
                  (o.SUBSCRIPTION === TRUE || o.CREATED_BY === userEmail) &&
                  (o.TOPIC_TYPE !== "TOPIC" || o.SUBSCRIPTION === TRUE)
              ),
              userToken
            )
          );
        } else {
          dispatch(curatedRegHubTopicsHaveBeenLoaded([], [], userToken));
        }
      })
      .catch((err) => {
        dispatch(
          curatedRegHubTopicsLoadedWithError(
            err.response ? err.response.data : err
          )
        );
      });
  };
}

export function singleTopicIsLoading(singleTopicIsLoading) {
  return {
    type: GET_SINGLE_CURRENT_TOPIC_IS_LOADING,
    singleTopicIsLoading,
  };
}

export function singleTopicIsLoadedWithError() {
  return {
    type: GET_SINGLE_CURRENT_TOPIC_LOADED_WITH_ERROR,
  };
}

export function singleTopicIsLoaded(singleTopic) {
  return {
    type: GET_SINGLE_CURRENT_TOPIC_IS_LOADED,
    singleTopic,
  };
}

export function getSingleTopic(userToken, id) {
  return (dispatch) => {
    dispatch(singleTopicIsLoading(true));
    axios({
      url: GET_TOPICS,
      params: {
        usertoken: userToken,
        topic_id: id,
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    })
      .then((response) => {
        response?.data?.RegHub_response.forEach(
          (o) => (
            sessionStorage.setItem("TOPIC_SEARCHTAGS", o.TOPIC_SEARCHTAGS),
            (o.TOPIC_ICON_NAME = o.TOPIC_NAME.replace(/\s+/g, "-")),
            (o.TOPIC_ICON_PATH = IMAGE_BASE + o.TOPIC_ICON_NAME + ".jpg"),
            o.TOPIC_ICON_NAME
          )
        );

        let data = response?.data?.RegHub_response?.filter(
          (o) => o?.TOPIC_ID == id
        )[0]?.TOPIC_ID;
        console.log("data", data);
        dispatch(
          singleTopicIsLoaded(
            response?.data?.RegHub_response?.filter((o) => o.TOPIC_ID == id)[0]
          )
        );
        // localStorage.setItem("singleTopicId", data);
        localStorage.setItem("singleTopicId", JSON.stringify(data));
      })
      .catch((err) => {
        dispatch(
          singleTopicIsLoadedWithError(err.response ? err.response.data : err)
        );
      });
  };
}

export function createNewTopic(
  usertoken,
  topic_name,
  search_criteria,
  new_topic,
  userEmail,
  topic_audience
) {
  return (dispatch) => {
    axios({
      url: ADD_TOPIC,
      params: {
        usertoken,
        topic_name,
        search_criteria,
        new_topic,
        topic_search: topic_name,
        topic_audience,
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    })
      .then((response) => {
        dispatch(getCuratedRegHubTopics(usertoken, userEmail));
        dispatch(topicSuccessMessageRaised(response.data));
      })
      .catch((err) => {
        dispatch(
          topicErrorMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function updateCustomTopic(
  usertoken,
  topic_name,
  search_criteria,
  new_topic,
  userEmail,
  topic_audience,
  topic_id
) {
  return (dispatch) => {
    axios({
      url: UPDATE_TOPIC,
      params: {
        usertoken,
        topic_name,
        search_criteria,
        new_topic,
        topic_search: topic_name,
        topic_audience,
        topic_id,
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    })
      .then((response) => {
        dispatch(getSingleTopic(usertoken, topic_id));
        dispatch(topicSuccessMessageRaised(response.data));
      })
      .catch((err) => {
        dispatch(
          topicErrorMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function createTopicGroup(
  usertoken,
  topic_name,
  topic_search,
  topic_audience,
  userEmail
) {
  return (dispatch) => {
    axios({
      url: ADD_TOPIC,
      params: {
        usertoken,
        topic_name,
        topic_search,
        topic_audience,
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    })
      .then((response) => {
        dispatch(getCuratedRegHubTopics(usertoken, userEmail));
        dispatch(topicSuccessMessageRaised(response.data));
      })
      .catch((err) => {
        dispatch(
          topicErrorMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function deleteTopicGroup(usertoken, userEmail, topic_id) {
  return (dispatch) => {
    axios({
      url: DELETE_TOPIC,
      params: {
        usertoken,
        topic_id,
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    })
      .then((response) => {
        dispatch(topicSuccessMessageRaised(response.data));
        dispatch(getCuratedRegHubTopics(usertoken, userEmail));
      })
      .catch((err) => {
        dispatch(
          topicErrorMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function updateTopicGroup(
  usertoken,
  userEmail,
  topic_id,
  topic_name,
  topic_search,
  topic_audience
) {
  return (dispatch) => {
    axios({
      url: UPDATE_TOPIC,
      params: {
        usertoken,
        topic_id,
        topic_name,
        topic_search,
        topic_audience,
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    })
      .then((response) => {
        dispatch(topicSuccessMessageRaised(response.data));
        dispatch(getCuratedRegHubTopics(usertoken, userEmail));
      })
      .catch((err) => {
        dispatch(
          topicErrorMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function doRestartTopicMessages() {
  return (dispatch) => {
    dispatch(restartTopicMessages());
  };
}

export function restartTopicMessages() {
  return {
    type: RESTART_TOPIC_MESSAGES,
  };
}

export function doSubscribeToTopic(
  usertoken,
  topic_id,
  topic_name,
  frequency,
  only_curated_news,
  filter
) {
  return (dispatch) => {
    axios({
      url: SUBSCRIBE_TOPIC,
      params: {
        usertoken,
        topic_id,
        topic_name,
        frequency,
        only_curated_news,
        filter,
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    })
      .then((response) => {
        dispatch(topicSuccessMessageRaised(response.data));
        dispatch(getUserSubscription(usertoken, topic_name));
        dispatch(getSingleTopic(usertoken, topic_id));
      })
      .catch((err) => {
        dispatch(topicErrorMessageRaised(err.response.data));
        dispatch(getSingleTopic(usertoken, topic_id));
      });
  };
}

export function getUserSubscription(usertoken, topic_name) {
  return (dispatch) => {
    axios({
      url: GET_USER_SUBSCRIPTION,
      params: {
        usertoken,
        topic_name,
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    })
      .then((response) => {
        response?.data?.RegHub_response.map((item) => {
          dispatch(setAdditionalParams(item.FILTER));
          dispatch(setSubscriptionFrequency(item.FREQUENCY));
          dispatch(setSubscriptionTypes(item.ONLY_CURATED));
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
}

export function doUnsubscribeToTopic(usertoken, topic_id, subscription_id) {
  return (dispatch) => {
    axios({
      url: UNSUBSCRIBE_TOPIC,
      params: {
        usertoken,
        subscription_id,
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    })
      .then((response) => {
        dispatch(topicSuccessMessageRaised(response.data));
        dispatch(getSingleTopic(usertoken, topic_id));
      })
      .catch((err) => {
        dispatch(topicErrorMessageRaised(err.response.data));
        dispatch(getSingleTopic(usertoken, topic_id));
      });
  };
}

export function topicSuccessMessageRaised(topicSuccessMessage) {
  return {
    type: TOPIC_SUCCESS_MESSAGE_RAISED,
    topicSuccessMessage,
  };
}

export function topicErrorMessageRaised(topicErrorMessage) {
  return {
    type: TOPIC_ERROR_MESSAGE_RAISED,
    topicErrorMessage,
  };
}
